export default __webpack_public_path__ + "static/project-slide-2-415-700-cf6aab480ffe701baf7b1af671f64bc7.webp";